import { INTEGRATE_SUPPORTER_ACCOUNTS } from 'actions/supporters'
import { SIGN_IN } from 'actions/auth'

const setWithdrawalAccounts = (state, action) => (
  // TODO: might be better to handle the null case on the backend. This is an issue
  // with how we're normalizing where we can account for empty arrays for has_many but not optional has_one relations
  action.payload.data.entities.withdrawalAccounts || {}
)

const handlers = {
  [`${INTEGRATE_SUPPORTER_ACCOUNTS}_FULFILLED`]: setWithdrawalAccounts,
  [`${SIGN_IN}_FULFILLED`]: setWithdrawalAccounts
}

export default function withdrawalAccountsReducer (state = {}, action) {
  const handler = handlers[action.type]
  return handler ? handler(state, action) : state
}
